export interface StarOption {
  id: string
  label?: string
  rating?: number
  isChecked: boolean
}

export type PriceRangeValue = [number, number]

export const starOptions: StarOption[] = [
  { id: 'any', label: 'Любая', isChecked: true },
  { id: 'five', rating: 5, isChecked: false },
  { id: 'four', rating: 4, isChecked: false },
  { id: 'three', label: 'и меньше', rating: 3, isChecked: false },
  { id: 'without', label: 'Без звезд', isChecked: false },
]

export const defaultPriceRange: PriceRangeValue = [0, 100]

export interface KyrgyzstanFiltersState {
  realtyTypeIds?: number[]
  priceRange: PriceRangeValue
  starRatings?: number[]
}
